import { render, staticRenderFns } from "./BtnTrocarPlano.vue?vue&type=template&id=02433a80&"
import script from "./BtnTrocarPlano.vue?vue&type=script&lang=js&"
export * from "./BtnTrocarPlano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports